<template>
    <div>
        <div class="search-layout-results hm-ad-list-results-head">
            <div class="slr-left">
                <small v-if="state.meta.listSubtitle">{{ state.meta.listSubtitle }}&nbsp;</small>
                <strong>{{ tr('results.count', ':count results', { count: state.meta.totalResults }) }}</strong>
            </div>
            <div class="slr-right">
                <select
                    class="input select hm-ad-list-sort-select"
                    v-model="state.sort"
                    :aria-label="tr('sort.aria', 'Sort listings')"
                    @change="triggerSort"
                >
                    <option value="price_asc">{{ tr('sort.price_asc', 'Lowest price') }}</option>
                    <option value="price_desc">{{ tr('sort.price_desc', 'Highest price') }}</option>
                    <option value="area_asc">{{ tr('sort.area_asc', 'Smallest area (m²)') }}</option>
                    <option value="area_desc">{{ tr('sort.area_desc', 'Largest area (m²)') }}</option>
                    <option value="newest">{{ tr('sort.newest', 'Newest listings') }}</option>
                    <option value="oldest">{{ tr('sort.oldest', 'Oldest listings') }}</option>
                    <option value="room_asc">{{ tr('sort.room_asc', 'Fewest rooms') }}</option>
                    <option value="room_desc">{{ tr('sort.room_desc', 'Most rooms') }}</option>
                    <option value="floor_asc">{{ tr('sort.floor_asc', 'Lowest floor') }}</option>
                    <option value="floor_desc">{{ tr('sort.floor_desc', 'Highest floor') }}</option>
                </select>
            </div>
        </div>
        <div class="search-layout-list">
            <template v-if="state.items.length">
                <template v-for="(chunk, chunkIndex) in chunkedItems" :key="'chunk-container-' + chunkIndex">
                    <ul class="w100" style="float:left; width:100%; clear:both;">
                        <li v-for="ad in chunk" :key="'ad-li-' + ad.id">
                            <div
                                class="search-layout-item"
                                :class="{'is-featured': ad.is_featured, 'is-eids-verified': ad.is_eids_verified}"
                                :data-ad-id="ad.id"
                                @mouseenter="emitListItemHover(ad)"
                                @mouseleave="emitListItemLeave(ad)"
                                @focusin="emitListItemHover(ad)"
                                @focusout="emitListItemLeave(ad)"
                            >

                                <div class="ad-featured-badge" v-if="ad.is_featured">
                                    <i class="ph-fill ph-star"></i> {{ tr('card.featured', 'Featured') }}
                                </div>

                                <div class="sli-photo">
                                    <!-- SLICK SLIDER -->
                                    <div class="slider-sli-wrap" v-memo="[ad.id]">
                                        <div class="slider-sli" :data-id="ad.id">
                                            <div
                                                v-for="(img, idx) in ad.gallery"
                                                :key="ad.id + '-g-' + idx"
                                                class="slider-sli-item"
                                            >
                                                <a :href="ad.url">
                                                    <picture>
                                                        <img :src="img" :alt="ad.title" loading="lazy" />
                                                    </picture>
                                                </a>
                                            </div>
                                        </div>

                                        <!-- Counter sadece 2+ görselde -->
                                        <div class="slider-counter" v-if="ad.gallery && ad.gallery.length > 1"></div>
                                    </div>

                                    <!-- Thumbnail strip -->
                                    <a :href="ad.url" class="sli-photo-gallery" v-if="ad.gallery && ad.gallery.length >= 4">
                                        <picture v-for="(img, idx) in ad.gallery.slice(1, 4)" :key="ad.id + '-th-' + idx">
                                            <img :src="img" alt="" />
                                        </picture>
                                    </a>
                                </div>

                                <div class="sli-content">
                                    <div class="sli-content-top">
                                        <div style="display:flex; align-items:center;">
                                            <div class="sli-content-price">{{ ad.price }}</div>

                                            <div class="sli-content-price-icon" v-if="ad.price_popup && ad.price_popup.length">
                                                <i
                                                    class="hm-currency-symbols"
                                                    data-fancybox
                                                    :data-src="'#fancy-price-currency-' + ad.id"
                                                 role="button" tabindex="0" :aria-label="tr('card.price_in_currencies', 'Price in other currencies')" :title="tr('card.price_in_currencies', 'Price in other currencies')"><img :src="currencyIconUrl" alt="" aria-hidden="true" width="26" height="26" /></i>
                                            </div>
                                        </div>

                                        <div class="my-fancy" v-if="ad.price_popup && ad.price_popup.length" :id="'fancy-price-currency-' + ad.id">
                                            <div class="my-fancy-wrap" style="max-width:480px !important;">
                                                <div class="fancy-title">{{ tr('card.price_in_currencies', 'Price in other currencies') }}</div>
                                                <div class="fancy-language">
                                                    <ul>
                                                        <li v-for="(row, idx) in ad.price_popup" :key="ad.id + '-price-' + idx">
                                                            <a href="javascript:void(0)">
                                                                <small>{{ row.label }} - <strong>{{ row.price }}</strong></small>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="sli-content-real-estate" v-if="ad.owner_logo">
                                            <picture><img :src="ad.owner_logo" alt="" loading="lazy" @error="applyOwnerLogoFallback" /></picture>
                                        </div>
                                    </div>


                                    <div class="sli-content-center">
                                        <div class="sli-content-title">
                                            <a :href="ad.url">{{ ad.title }}</a>
                                        </div>

                                        <div class="sli-eids-row">
                                            <div
                                                v-if="ad.is_eids_verified"
                                                class="sli-eids-verified"
                                                :title="eidsVerifiedText"
                                                :aria-label="eidsVerifiedText"
                                            >
                                                <img
                                                    :src="eidsImageUrl"
                                                    alt="EİDS"
                                                    loading="lazy"
                                                />
                                                <span>{{ eidsVerifiedText }}</span>
                                            </div>

                                            <div class="button-cta fr">
                                                <!-- GİZLE -->
                                                <button
                                                    type="button"
                                                    class="button-cta-item"
                                                    :title="tr('card.hide', 'Hide')"
                                                    @click.prevent="openHideConfirm(ad)"
                                                >
                                                    <i class="ph-light ph-eye"></i>
                                                </button>

                                                <!-- FAVORİ -->
                                                <button
                                                    type="button"
                                                    class="button-cta-item save js-open-fav-list"
                                                    :class="{ saved: ad.is_favorite }"
                                                    :data-id="ad.id"
                                                    :data-fav-lists="JSON.stringify(ad.in_favorite_lists || [])"
                                                    :data-login-url="ad.login_url"
                                                    data-fancybox
                                                    data-src="#fancy-add-to-favorites"
                                                    data-type="inline"
                                                    :title="tr('card.add_favorite', 'Add to favorites')"
                                                >
                                                    <i class="ph-light ph-heart"></i>
                                                    <i class="ph-fill ph-heart"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div v-if="ad.location" class="sli-content-location">
                                            <i class="ph-light ph-map-pin"></i>
                                            <span>{{ ad.location }}</span>
                                        </div>

                                        <div v-if="typeBadgeText(ad)" class="sli-list-badges">
                                            <span class="sli-sale-badge">{{ typeBadgeText(ad) }}</span>
                                        </div>

                                        <div v-if="ad.publish_date" class="sli-content-location sli-date-row">
                                            <i class="ph-light ph-calendar-blank"></i>
                                            <span>{{ ad.publish_date }}</span>
                                        </div>

                                        <div v-if="visibleFeatures(ad).length" class="sli-content-features sli-list-feature-grid">
                                            <ul>
                                                <li v-for="(feat, fIdx) in visibleFeatures(ad)" :key="ad.id + '-f-' + fIdx">
                                                    <div class="feature-item">
                                                        <i :class="feat.icon"></i>
                                                        <span v-if="feat.label" class="feature-key">{{ shortFeatureLabel(feat.label) }}:</span>
                                                        <span class="feature-value">{{ feat.text }}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="sli-content-bottom">
                                        <div class="button-cta" style="display:flex; align-items:center; gap:12px;">

                                            <button
                                                v-if="props.config?.showAppointment !== false"
                                                type="button"
                                                class="button-cta-item js-open-list-appointment"
                                                data-fancybox
                                                data-src="#fancy-make-appointment-list"
                                                :data-ad-id="ad.id"
                                                :data-prefill-url="ad.appointment_prefill_url"
                                                :data-store-url="ad.appointment_store_url"
                                                :data-login-url="ad.login_url"
                                            >
                                                <i class="ph-light ph-calendar-dots"></i><small>{{ tr('card.visit_request', 'Visit request') }}</small>
                                            </button>
                                            <button
                                                type="button"
                                                class="button-cta-item js-open-list-msg"
                                                :data-id="ad.id"
                                                :data-owner-name="ad.owner_name"
                                                :data-owner-logo="ad.owner_logo"
                                                :data-login-url="ad.login_url"
                                                @click="openMessagePopup(ad, $event)"
                                            >
                                                <i class="ph-light ph-chat-circle-text"></i><small>{{ tr('message.send', 'Send message') }}</small>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                                <div
                                    v-if="ad.is_project && ad.project_plan_cards && ad.project_plan_cards.length"
                                    class="w100 sli-slider-wrap"
                                >
                                    <div class="floorplan-slider">
                                        <button type="button" class="floorplan-slider-arrow left">
                                            <i class="ph ph-caret-left"></i>
                                        </button>

                                        <ul class="floorplan-slider-scroll">
                                            <li
                                                v-for="plan in ad.project_plan_cards"
                                                :key="ad.id + '-plan-' + plan.id"
                                            >
                                                <div class="floorplan-item">
                                                    <picture>
                                                        <a :href="plan.url || ad.url">
                                                            <img :src="plan.cover" :alt="plan.title" loading="lazy" />
                                                        </a>
                                                    </picture>

                                                    <section>
                                                        <div class="floorplan-item-title">
                                                            <a :href="plan.url || ad.url">{{ plan.title }}</a>
                                                        </div>

                                                        <div class="floorplan-item-price" v-if="plan.price">
                                                            {{ plan.price }}
                                                        </div>

                                                        <div
                                                            class="floorplan-item-features"
                                                            v-if="plan.features && plan.features.length"
                                                        >
                                                            <ul>
                                                                <li
                                                                    v-for="(feat, pfIdx) in plan.features.slice(0, 4)"
                                                                    :key="ad.id + '-plan-' + plan.id + '-feat-' + pfIdx"
                                                                >
                                                                    <div class="feature-item">
                                                                        <i :class="feat.icon"></i>
                                                                        <span v-if="feat.label" class="feature-key">{{ feat.label }}:</span>
                                                                        <span>{{ feat.text }}</span>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </section>
                                                </div>
                                            </li>
                                        </ul>

                                        <button type="button" class="floorplan-slider-arrow right">
                                            <i class="ph ph-caret-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <!-- KURUMSAL ÖNERİ BLOĞU: ACENTE / İNŞAAT / KARMA -->
                    <div
                        v-if="state.companies.length > 0 && chunkIndex === 0"
                        class="w100 mb30 mt10 vue-managed"
                        style="float:left; width:100%; clear:both;"
                    >
                        <div class="block-title slim">
                            <strong class="fs-17">{{ companySectionTitle }}</strong>
                        </div>

                        <div class="slider-real-estates">
                            <div
                                v-for="company in state.companies"
                                :key="company.entity_type + '-' + company.id + '-' + chunkIndex"
                                class="slider-list-item slider-re-item"
                            >
                                <a :href="company.url" class="list-item list-item-real-estate">
                                    <div class="list-item-photo">
                                        <picture>
                                            <img :src="company.cover" :alt="company.name" loading="lazy" />
                                            <div class="badge-experience" v-if="company.experience">{{ company.experience }}</div>
                                        </picture>
                                    </div>
                                    <div class="list-item-logo">
                                        <picture><img :src="company.logo" :alt="company.name" loading="lazy" /></picture>
                                    </div>
                                    <div class="list-item-content">
                                        <div class="list-item-title">{{ company.name }}</div>
                                        <div class="list-item-tags">
                                            <div class="in">
                                                <small>{{ tr('agency.total_listings', ':count listings', { count: company.ad_count }) }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </template>
            </template>

            <div v-if="!state.loading && state.items.length === 0" class="alert alert-info">
                {{ tr('results.empty', 'No listings matched your search.') }}
            </div>
        </div>

        <div
            ref="observerElement"
            class="loading-area"
            style="float:left; width:100%; min-height:50px; clear:both;"
        >
            <div v-if="state.loading" class="spinner-container">
                <div class="custom-spinner"></div>
                <span>{{ tr('results.loading', 'Loading...') }}</span>
            </div>
            <div v-else-if="!state.nextUrl && state.items.length > 0" class="end-text">
                {{ tr('results.all_loaded', 'All listings have been loaded.') }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, reactive, ref, computed, nextTick } from 'vue'

const props = defineProps({ config: { type: Object, required: true } })

const runtimeI18n = window.AD_LIST_I18N || {}
const eidsImageUrl = String(props.config?.eidsImageUrl || '/images/eids.png')
const currencyIconUrl = String(props.config?.currencyIconUrl || '/assets/images/exchange.png')
const ownerLogoFallback = String(props.config?.ownerLogoFallback || '/favicon.png')

function applyOwnerLogoFallback(event) {
    const image = event?.target
    if (!image || image.dataset.ownerLogoFallbackApplied === '1') return

    image.dataset.ownerLogoFallbackApplied = '1'
    image.src = ownerLogoFallback
}
const eidsVerifiedText = String(props.config?.eidsVerifiedText || 'EİDS verified listing')

function tr(path, fallback = '', vars = {}) {
    let value = runtimeI18n
    for (const part of String(path || '').split('.')) {
        if (!value || typeof value !== 'object' || !(part in value)) {
            value = null
            break
        }
        value = value[part]
    }

    let text = (typeof value === 'string' && value !== '') ? value : String(fallback || '')
    Object.entries(vars || {}).forEach(([key, replacement]) => {
        text = text.split(':' + key).join(String(replacement ?? ''))
    })
    return text
}

const ALLOWED_SORTS = [
    'price_asc', 'price_desc', 'area_asc', 'area_desc',
    'newest', 'oldest', 'room_asc', 'room_desc', 'floor_asc', 'floor_desc',
]

const requestedSort = new URLSearchParams(window.location.search).get('sort') || 'newest'

const state = reactive({
    items: (props.config?.initial?.items || []).map(prepareAdItem),
    companies: props.config?.initial?.companies || props.config?.initial?.agencies || [],
    companyMode: props.config?.initial?.company_mode || 'agency',
    companyLabels: props.config?.initial?.company_labels || {},
    detectedRegion: props.config?.initial?.detected_region || null,
    meta: props.config?.initial?.meta || { totalResults: 0, listSubtitle: '' },
    nextUrl: props.config?.initial?.pagination?.next_page_url || null,
    sort: ALLOWED_SORTS.includes(requestedSort) ? requestedSort : 'newest',
    loading: false,
    adToHide: null,
})

const observerElement = ref(null)
let observer = null
let inflight = null
let requestSequence = 0

const chunkedItems = computed(() => {
    const res = []
    const size = 5
    for (let i = 0; i < state.items.length; i += size) {
        res.push(state.items.slice(i, i + size))
    }
    return res
})

const currentRegionName = computed(() => {
    if (state.detectedRegion) return state.detectedRegion
    return tr('agency.region_default', 'Local')
})

const companySectionTitle = computed(() => {
    const region = currentRegionName.value
    const agencyLabel = String(state.companyLabels?.agency || tr('agency.label', 'Real estate agencies'))
    const constructionLabel = String(state.companyLabels?.construction || 'Construction companies')

    if (state.companyMode === 'construction') {
        return `${region} ${constructionLabel}`.trim()
    }

    if (state.companyMode === 'mixed') {
        return `${region} ${agencyLabel} / ${constructionLabel}`.trim()
    }

    return tr('agency.region_agencies', ':region real estate agencies', { region })
})

function isFrontAuthed() {
    if (typeof props.config?.isAuthenticated !== 'undefined') return !!props.config.isAuthenticated
    if (typeof window.FRONT_IS_AUTHED !== 'undefined') return !!window.FRONT_IS_AUTHED
    return !!(window.FRONT_ACTOR_KEY && window.FRONT_ACTOR_KEY !== 'guest')
}

function resolveLoginUrl(ad = null) {
    return ad?.login_url || props.config?.loginUrl || window.FRONT_LOGIN_URL || null
}

function notifyGuestAuthRequired(ad = null) {
    const loginUrl = resolveLoginUrl(ad)

    if (window.UI && typeof window.UI.openAuthRequired === 'function') {
        window.UI.openAuthRequired({
            loginUrl,
            title: tr('auth.required_title', 'Sign in required'),
            message: tr('auth.list_actions_message', 'Sign in or create an account to hide a listing, add it to favorites, or contact the listing owner.')
        })
        return
    }

    if (window.showToast) {
        window.showToast('info', tr('auth.required_title', 'Sign in required'), tr('auth.membership_required_short', 'An account is required for this action.'))
    }
}

function messageUrlForAd(ad) {
    const id = ad?.id ? String(ad.id) : ''
    const template = String(props.config?.messageUrlTemplate || props.config?.message_url_template || '').trim()

    if (!id || !template) return null

    return template
        .replace('__AD_ID__', encodeURIComponent(id))
        .replace('999999', encodeURIComponent(id))
}

function showInlineFancybox(selector) {
    if (window.Fancybox && typeof window.Fancybox.show === 'function') {
        window.Fancybox.show([{ src: selector, type: 'inline' }])
        return true
    }

    if (window.jQuery?.fancybox && typeof window.jQuery.fancybox.open === 'function') {
        window.jQuery.fancybox.open({ src: selector, type: 'inline' })
        return true
    }

    const popup = document.querySelector(selector)
    if (popup) {
        popup.style.display = 'block'
        popup.removeAttribute('aria-hidden')
        return true
    }

    return false
}

function openMessagePopup(ad, event = null) {
    event?.preventDefault?.()
    event?.stopPropagation?.()

    if (!isFrontAuthed()) {
        const loginUrl = resolveLoginUrl(ad)

        if (window.UI && typeof window.UI.openAuthRequired === 'function') {
            window.UI.openAuthRequired({
                loginUrl,
                title: tr('auth.required_title', 'Sign in required'),
                message: tr('auth.message_required', 'Sign in or create an account to message the listing owner.')
            })
        } else {
            notifyGuestAuthRequired(ad)
        }
        return
    }

    const popup = document.getElementById('fancy-list-message')
    const url = messageUrlForAd(ad)

    if (!popup || !url) {
        window.showToast?.('error', tr('message.technical_error', 'Technical error'), tr('card.message_link_failed', 'The message link could not be prepared.'))
        return
    }

    const image = popup.querySelector('#msg-popup-img')
    const name = popup.querySelector('#msg-popup-name')
    const submit = popup.querySelector('.js-list-msg-submit')
    const reason = popup.querySelector('.js-ad-message-reason')
    const body = popup.querySelector('.js-list-msg-body')
    const policy = popup.querySelector('.js-policy-check')

    if (image) {
        if (ad?.owner_logo) {
            image.src = ad.owner_logo
            image.closest('picture')?.removeAttribute('hidden')
        } else {
            image.removeAttribute('src')
            image.closest('picture')?.setAttribute('hidden', 'hidden')
        }
    }

    if (name) name.textContent = ad?.owner_name || tr('message.owner', 'Listing owner')
    if (reason) reason.value = ''
    if (body) body.value = ''
    if (policy) policy.checked = false

    if (submit) {
        submit.dataset.url = url
        submit.dataset.loginUrl = resolveLoginUrl(ad) || ''
        submit.disabled = false
        submit.innerHTML = '<small>' + tr('message.send', 'Send message') + '</small> <i class="ph-light ph-chat-circle-text"></i>'
    }

    showInlineFancybox('#fancy-list-message')
}

function emitSideMapEvent(name, ad = null) {
    const id = ad?.id ? String(ad.id) : ''
    window.dispatchEvent(new CustomEvent(name, { detail: { id } }))
}

function emitListItemHover(ad) {
    emitSideMapEvent('ad-list:item-hover', ad)
}

function emitListItemLeave(ad) {
    emitSideMapEvent('ad-list:item-leave', ad)
}

function notifyListItemsUpdated(mode = '') {
    window.dispatchEvent(new CustomEvent('ad-list:items-updated', { detail: { mode } }))
}

function typeBadgeText(ad) {
    const backendText = String(ad?.type_badge || '').trim()

    if (backendText) {
        return backendText
    }

    return [ad?.transaction_label, ad?.category_label]
        .map((item) => String(item || '').trim())
        .filter(Boolean)
        .join(' / ')
}

function shortFeatureLabel(label) {
    const text = String(label || '').trim()
    if (!text) return ''

    return text
        .replace(/\s+Sayısı$/i, '')
        .replace(/\s+Adedi$/i, '')
        .replace(/^Metrekare$/i, 'm²')
}

function visibleFeatures(ad) {
    const features = Array.isArray(ad?.features) ? ad.features : []

    return features
        .filter((feat) => {
            const label = String(feat?.label || '').trim().toLocaleLowerCase('tr-TR')
            const text = String(feat?.text || '').trim()

            if (!text) return false
            if (label === 'kategori') return false

            return true
        })
        .slice(0, 6)
}

function normalizeGallery(item) {
    let g = []
    if (Array.isArray(item.gallery)) g = item.gallery
    else if (item.gallery && typeof item.gallery === 'object') g = Object.values(item.gallery)

    // slick için en az 1 görsel garantisi
    if ((!g || !g.length) && item.img) g = [item.img]

    // boşları temizle
    return (g || []).filter(Boolean)
}

function prepareAdItem(item) {
    return {
        ...item,
        gallery: normalizeGallery(item),
        project_plan_cards: normalizeProjectPlanCards(item),
        is_project: !!item.is_project,
        project_plan_total: Number(item.project_plan_total || 0),
        is_eids_verified: !!item.is_eids_verified,

        currentSlide: 0,
        renderKey: 0,
    }
}

/**
 * SLICK init: sadece yeni eklenenleri init eder.
 * - slider counter: init/reInit/afterChange eventlerinden günceller.
 */
const runSlick = async () => {
    await nextTick()

    setTimeout(() => {
        if (window.initAgencySlider) {
            window.jQuery?.('.slider-real-estates')
                ?.not('.slick-initialized')
                ?.each(function () {
                    window.initAgencySlider(this)
                })
        }

        window.jQuery?.('.slider-sli')
            ?.not('.slick-initialized')
            ?.each(function () {
                const $s = window.jQuery(this)

                $s.on('init reInit afterChange', function (e, slick, cur) {
                    const i = (cur || 0) + 1
                    window.jQuery(this)
                        .closest('.slider-sli-wrap')
                        .find('.slider-counter')
                        .text(i + '/' + slick.slideCount)
                })

                $s.slick({
                    arrows: true,
                    dots: false,
                    speed: 350,
                    autoplay: false,
                })
            })

        // YENİ
        if (window.initFloorplanSlider) {
            const root = document.getElementById('ad-list-vue')
            window.initFloorplanSlider(root)
        }
    }, 120)
}

const refreshObserver = () => {
    nextTick(() => {
        if (observer && observerElement.value) {
            observer.unobserve(observerElement.value)
            observer.observe(observerElement.value)
        }
    })
}

const RADIUS_STATE_KEYS = ['lat', 'lng', 'radius', 'radius_label', 'radius_mode']

function mergeRadiusStateIntoUrl(url) {
    if (!(url instanceof URL)) return url

    if (window.HM_RADIUS_STATE && typeof window.HM_RADIUS_STATE.syncFromDom === 'function') {
        window.HM_RADIUS_STATE.syncFromDom()
    }

    if (window.HM_RADIUS_STATE && typeof window.HM_RADIUS_STATE.mergeIntoUrl === 'function') {
        const merged = window.HM_RADIUS_STATE.mergeIntoUrl(url)
        return merged instanceof URL ? merged : url
    }

    // State bridge yüklenemese bile liste formundaki aktif yakın çevre
    // parametrelerini AJAX isteğine taşı. Böylece sıralama/filtre değişiminde
    // seçili merkez ve çap kaybolmaz.
    const form = document.getElementById('listFilterForm')
    if (!form) return url

    const values = Object.fromEntries(
        RADIUS_STATE_KEYS.map((key) => [key, String(form.querySelector(`[name="${key}"]`)?.value || '').trim()])
    )

    const active = values.lat && values.lng && values.radius
    if (!active) return url

    RADIUS_STATE_KEYS.forEach((key) => {
        if (values[key]) url.searchParams.set(key, values[key])
    })

    return url
}

function restoreRadiusState(reason = 'vue') {
    if (window.HM_RADIUS_STATE && typeof window.HM_RADIUS_STATE.restore === 'function') {
        window.HM_RADIUS_STATE.restore({ reason, history: true })
    }

    window.dispatchEvent(new CustomEvent('ad-list:radius-state-restore', {
        detail: { reason },
    }))
}

window.AD_LIST_VUE_FETCH = (params) => {
    if (window.HM_RADIUS_STATE && typeof window.HM_RADIUS_STATE.syncFromDom === 'function') {
        window.HM_RADIUS_STATE.syncFromDom()
    }

    if (typeof params === 'string') {
        const requested = new URL(params, window.location.origin).searchParams.get('sort')
        if (ALLOWED_SORTS.includes(requested)) state.sort = requested
    }

    fetchList(params, 'replace')
}

function canonicalNextPageUrl(value) {
    if (!value) return null

    const url = new URL(value, window.location.origin)
    url.searchParams.set('sort', ALLOWED_SORTS.includes(state.sort) ? state.sort : 'newest')
    url.searchParams.delete('include_map')

    return url.toString()
}

async function fetchList(urlOrQuery, mode = 'replace') {
    if (mode === 'append' && state.loading) return

    const requestId = ++requestSequence
    const controller = new AbortController()

    if (inflight) inflight.abort()
    inflight = controller
    state.loading = true

    try {
        let urlFetch
        const origin = window.location.origin

        const normalizeParamKey = (key) => {
            if (key === 'price_min') return 'min_price'
            if (key === 'price_max') return 'max_price'
            return key
        }

        const normalizeNumericValue = (value) => {
            if (value === null || value === undefined) return ''
            return String(value)
                .trim()
                .replace(/\s*(₺|tl|try|m²|m2|㎡|metrekare|sqm)\s*/giu, '')
                .replace(/[^0-9,.-]/g, '')
        }

        const normalizePriceParamsOnUrl = (url) => {
            const min = url.searchParams.get('min_price') || url.searchParams.get('price_min') || ''
            const max = url.searchParams.get('max_price') || url.searchParams.get('price_max') || ''

            url.searchParams.delete('price_min')
            url.searchParams.delete('price_max')

            if (min) url.searchParams.set('min_price', normalizeNumericValue(min))
            else url.searchParams.delete('min_price')

            if (max) url.searchParams.set('max_price', normalizeNumericValue(max))
            else url.searchParams.delete('max_price')
        }

        const normalizeCategoryParamsOnUrl = (url) => {
            const rawCategoryId = String(url.searchParams.get('category_id') || '').trim()
            const categoryId = rawCategoryId.toLowerCase()
            const categorySlug = String(url.searchParams.get('category') || '').trim().toLowerCase()
            const allValues = ['all', '0', '*']

            if (rawCategoryId !== '') {
                if (allValues.includes(categoryId)) {
                    url.searchParams.delete('category_id')
                    url.searchParams.delete('main_category_id')
                    url.searchParams.delete('subcategory_id')
                    url.searchParams.set('category', 'all')
                    return
                }

                // Sayısal/gerçek kategori seçimi stale category=all işaretinden üstündür.
                if (categorySlug === 'all') {
                    url.searchParams.delete('category')
                }

                return
            }

            if (categorySlug === 'all') {
                url.searchParams.delete('main_category_id')
                url.searchParams.delete('subcategory_id')
                url.searchParams.set('category', 'all')
            }
        }

        if (typeof urlOrQuery === 'string') {
            urlFetch = new URL(urlOrQuery, origin)
            normalizePriceParamsOnUrl(urlFetch)
        } else {
            urlFetch = new URL(props.config.apiUrl, origin)
            const current = new URL(window.location.href)
            urlFetch.search = current.search
            urlFetch.searchParams.delete('page')
            urlFetch.searchParams.delete('include_map')
            normalizePriceParamsOnUrl(urlFetch)

            Object.entries(urlOrQuery || {}).forEach(([k, v]) => {
                const key = normalizeParamKey(k)
                const rawValue = Array.isArray(v) ? v.filter(Boolean).join(',') : v
                const value = ['min_price', 'max_price', 'm2_min', 'm2_max'].includes(key)
                    ? normalizeNumericValue(rawValue)
                    : (rawValue === null || rawValue === undefined ? '' : String(rawValue).trim())

                if (value.length) {
                    urlFetch.searchParams.set(key, value)
                    if (key === 'min_price') urlFetch.searchParams.delete('price_min')
                    if (key === 'max_price') urlFetch.searchParams.delete('price_max')
                } else {
                    urlFetch.searchParams.delete(key)
                    if (key === 'min_price') urlFetch.searchParams.delete('price_min')
                    if (key === 'max_price') urlFetch.searchParams.delete('price_max')
                }
            })
        }

        // Filtre popup/form eski main/sub category değerlerini URL'de bıraksa bile
        // son seçilen kategori tek ve canonical biçimde taşınır.
        normalizeCategoryParamsOnUrl(urlFetch)

        const urlSort = urlFetch.searchParams.get('sort')
        if (mode === 'replace' && ALLOWED_SORTS.includes(urlSort)) {
            state.sort = urlSort
        }
        if (!ALLOWED_SORTS.includes(state.sort)) state.sort = 'newest'

        // Her replace/append isteğinde aynı sıralama parametresi zorunlu tutulur.
        urlFetch.searchParams.set('sort', state.sort)

        // sort_ctx yalnızca backend'in ürettiği next_page_url üzerinde yaşar.
        // Yeni filtre/sıralama isteğinde eski snapshot kesinlikle kullanılmamalıdır.
        if (mode === 'replace') {
            urlFetch.searchParams.delete('sort_ctx')
            urlFetch.searchParams.delete('page')
        }

        // Yakın çevre state'i çağıran kodun gönderdiği params içinde olmasa bile
        // URL + form + session state üzerinden her AJAX isteğine zorunlu eklenir.
        urlFetch = mergeRadiusStateIntoUrl(urlFetch)

        if (mode === 'replace') urlFetch.searchParams.set('include_map', '1')
        else urlFetch.searchParams.delete('include_map')

        const res = await fetch(urlFetch.toString(), {
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            signal: controller.signal,
        })

        if (!res.ok) throw new Error(`Fetch Error (${res.status})`)
        const data = await res.json()

        // Daha yeni bir filtre/sıralama isteği başladıysa bu cevabın listeyi değiştirmesine izin verme.
        if (requestId !== requestSequence) return

        const responseSort = data?.meta?.activeSort
        if (ALLOWED_SORTS.includes(responseSort)) state.sort = responseSort

        const mappedItems = (data.items || []).map(prepareAdItem)

        if (mode === 'replace') {
            state.items = mappedItems
            state.companies = data.companies || data.agencies || []
            state.companyMode = data.company_mode || 'agency'
            state.companyLabels = data.company_labels || state.companyLabels || {}
            state.detectedRegion = data.detected_region || null

            window.scrollTo({ top: 0, behavior: 'auto' })

            let historyUrl = new URL(urlFetch.toString())
            historyUrl.searchParams.delete('include_map')
            historyUrl.searchParams.set('sort', state.sort)
            historyUrl = mergeRadiusStateIntoUrl(historyUrl)
            window.history.pushState({}, '', historyUrl.toString())

            if (window.__ADLIST_SIDEMAP__ && data.mapPoints) {
                window.__ADLIST_SIDEMAP__.setMarkers(data.mapPoints)
            }

            restoreRadiusState('ajax-replace')
            notifyListItemsUpdated('replace')
        } else {
            // Offset pagination sırasında veri değişse bile aynı ilanı iki kez basma.
            const existingIds = new Set(state.items.map(item => String(item.id)))
            const newItems = mappedItems.filter(item => !existingIds.has(String(item.id)))
            state.items.push(...newItems)

            if (
                window.__ADLIST_SIDEMAP__ &&
                typeof window.__ADLIST_SIDEMAP__.updateListedMarkers === 'function'
            ) {
                window.__ADLIST_SIDEMAP__.updateListedMarkers(newItems)
            }

            notifyListItemsUpdated('append')
        }

        state.meta = data.meta || {}
        state.nextUrl = canonicalNextPageUrl(data.pagination?.next_page_url || null)

        await runSlick()

        if (requestId !== requestSequence) return

        notifyListItemsUpdated(mode)

        if (mode === 'replace') {
            restoreRadiusState('ajax-render-complete')
        }
    } catch (err) {
        if (err.name !== 'AbortError' && requestId === requestSequence) console.error(err)
    } finally {
        // İptal edilen eski istek yeni isteğin loading/inflight state'ini bozamaz.
        if (requestId === requestSequence) {
            state.loading = false
            if (inflight === controller) inflight = null
            refreshObserver()
        }
    }
}

/* ===========================
   HIDE (GİZLE) AKIŞI - eski
   =========================== */
function openHideConfirm(ad) {
    if (!isFrontAuthed()) {
        notifyGuestAuthRequired(ad)
        return
    }

    state.adToHide = ad
    const triggerBtn = document.getElementById('hidden-confirm-trigger')
    if (triggerBtn) triggerBtn.click()
    else {
        if (confirm(tr('hidden.confirm', 'Are you sure you want to hide this listing?'))) confirmHideProcess()
    }
}

function resolveHideUrl(ad) {
    const id = ad?.id ? String(ad.id) : ''
    if (!id) return null

    const template = String(
        props.config?.hideUrlTemplate ||
        props.config?.hide_url_template ||
        props.config?.routes?.hideAd ||
        ''
    ).trim()

    if (template) {
        return template
            .replace('__AD_ID__', encodeURIComponent(id))
            .replace('999999', encodeURIComponent(id))
    }

    const apiUrl = String(props.config?.apiUrl || '')
    const marker = '/ilan/ara'
    const markerIndex = apiUrl.indexOf(marker)

    if (markerIndex >= 0) {
        return `${apiUrl.slice(0, markerIndex)}/ilan/${encodeURIComponent(id)}/gizle-toggle`
    }

    return null
}

async function confirmHideProcess() {
    if (!state.adToHide) return

    const ad = state.adToHide
    const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const url = resolveHideUrl(ad)

    if (!url) {
        if (window.showToast) window.showToast('error', tr('common.error', 'Error'), tr('card.hide_link_failed', 'The hide-listing link could not be prepared.'))
        return
    }

    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrf,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })

        if (res.status === 401) {
            notifyGuestAuthRequired(ad)
            return
        }

        if (res.ok) {
            state.items = state.items.filter((item) => item.id !== ad.id)
            state.meta.totalResults = Math.max(0, (state.meta.totalResults || 0) - 1)

            if (window.showToast) window.showToast('success', tr('card.hidden_title', 'Hidden'), tr('card.hidden_message', 'The listing was hidden successfully.'))
        } else {
            if (window.showToast) window.showToast('error', tr('common.error', 'Error'), tr('common.operation_failed', 'Operation failed.'))
        }
    } catch (e) {
        if (window.showToast) window.showToast('error', tr('common.error', 'Error'), tr('common.connection_failed_short', 'Connection error.'))
    } finally {
        if (window.Fancybox) window.Fancybox.close()
        else if (window.jQuery && window.jQuery.fancybox) window.jQuery.fancybox.close()

        state.adToHide = null
        await runSlick()
        refreshObserver()
    }
}

/* ===========================
   FAVORİ EVENT - eski
   =========================== */
function handleFavoriteChange(e) {
    const { adId, isFavorite, listIds } = e.detail || {}
    const ad = state.items.find((i) => String(i.id) === String(adId))
    if (!ad) return
    ad.is_favorite = !!isFavorite
    if (listIds) ad.in_favorite_lists = listIds
}

function normalizeProjectPlanCards(item) {
    let cards = []

    if (Array.isArray(item.project_plan_cards)) {
        cards = item.project_plan_cards
    } else if (item.project_plan_cards && typeof item.project_plan_cards === 'object') {
        cards = Object.values(item.project_plan_cards)
    }

    return (cards || []).filter(Boolean).map(card => ({
        ...card,
        features: Array.isArray(card.features)
            ? card.features.filter(Boolean)
            : (card.features && typeof card.features === 'object'
                ? Object.values(card.features).filter(Boolean)
                : []),
    }))
}

function triggerSort() {
    if (!ALLOWED_SORTS.includes(state.sort)) {
        state.sort = 'newest'
    }

    // URL'yi güncellemeden önce hidden input'u da güncelle ki diğer filtreler tetiklendiğinde kaybolmasın
    const hiddenSort = document.getElementById('formSortInput');
    if(hiddenSort) hiddenSort.value = state.sort;

    const url = new URL(window.location.href);
    url.searchParams.set('sort', state.sort);
    url.searchParams.delete('page');
    url.searchParams.delete('include_map');

    // Eski sıralamanın next_page_url'si observer tarafından kullanılmasın.
    state.nextUrl = null

    if (typeof window.AD_LIST_VUE_FETCH === 'function') {
        // URLSearchParams içindeki aynı isimli array parametrelerini kaybetme.
        // Object.fromEntries() owner_types[] / feature_value_ids[] / fields gibi
        // tekrar eden parametreleri tek değere düşürüyordu.
        window.AD_LIST_VUE_FETCH(url.toString());
    } else {
        window.location.href = url.toString();
    }
}

function handlePopState() {
    const requested = new URL(window.location.href).searchParams.get('sort') || 'newest'
    state.sort = ALLOWED_SORTS.includes(requested) ? requested : 'newest'
    state.nextUrl = null
    fetchList(window.location.href, 'replace')
}

onMounted(async () => {
    observer = new IntersectionObserver(
        (entries) => {
            const target = entries[0]
            if (target.isIntersecting && state.nextUrl && !state.loading) {
                fetchList(state.nextUrl, 'append')
            }
        },
        { root: null, rootMargin: '400px', threshold: 0 }
    )

    if (observerElement.value) observer.observe(observerElement.value)

    // back/forward ile listeyi ve select değerini birlikte güncelle
    window.addEventListener('popstate', handlePopState)

    // gizle confirm hook
    window.AD_LIST_CONFIRM_HIDE = confirmHideProcess

    // favori event hook
    window.addEventListener('ad-favorite-changed', handleFavoriteChange)

    // blade içindeki "Evet, Gizle" butonu
    const confirmBtn = document.getElementById('btn-confirm-hide-yes')
    if (confirmBtn) {
        confirmBtn.addEventListener('click', (e) => {
            e.preventDefault()
            window.AD_LIST_CONFIRM_HIDE?.()
        })
    }

    await runSlick()
})

onBeforeUnmount(() => {
    notifyListItemsUpdated('unmount')
    requestSequence++
    if (inflight) inflight.abort()
    if (observer) observer.disconnect()
    delete window.AD_LIST_VUE_FETCH
    delete window.AD_LIST_CONFIRM_HIDE
    window.removeEventListener('popstate', handlePopState)
    window.removeEventListener('ad-favorite-changed', handleFavoriteChange)
})
</script>

<style scoped>
.hm-ad-list-results-head {
    position: relative;
    z-index: 1;
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.hm-ad-list-sort-select {
    width: auto;
    min-width: 116px;
    height: 40px;
    padding: 0 34px 0 14px;
    border-radius: 8px;
    font-weight: 500;
    line-height: 38px;
}

@media (max-width: 560px) {
    .hm-ad-list-results-head {
        gap: 12px;
    }

    .hm-ad-list-sort-select {
        min-width: 108px;
        padding-left: 12px;
    }
}

.loading-area {
    float: left;
    width: 100%;
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 50px;
}
.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #da241d;
    font-weight: 600;
}
.custom-spinner {
    width: 30px;
    height: 30px;
    border: 4px solid rgba(218, 36, 29, 0.1);
    border-top-color: #da241d;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.end-text {
    color: #999;
    font-size: 14px;
    font-weight: 500;
}

/* İstersen eski slider-arrow stilleri kalabilir (slick arrows farklı class’lar kullanır) */
.slider-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.2s;
    font-size: 16px;
    color: #333;
}
.search-layout-item:hover .slider-arrow {
    opacity: 1;
}

/* Liste kartı: ana tasarımı bozmadan sade durum ve özellik düzeni */
.sli-eids-row {
    float: left;
    clear: both;
    width: 100%;
    margin: 7px 0 8px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.sli-eids-row .button-cta.fr {
    float: none;
    margin-left: auto;
    display: flex;
    align-items: center;
    column-gap: 8px;
}

.sli-eids-row .button-cta.fr .button-cta-item {
    margin: 0;
}

.sli-eids-verified {
    float: none;
    min-width: 0;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    width: auto;
    max-width: 100%;
    min-height: 30px;
    padding: 4px 9px 4px 6px;
    border: 1px solid rgba(22, 163, 74, .16);
    border-radius: 8px;
    background: rgba(22, 163, 74, .045);
    color: #334155;
    box-shadow: 0 4px 14px rgba(15, 23, 42, .04);
}

.sli-eids-verified img {
    display: block;
    flex: 0 0 auto;
    width: auto;
    height: 22px;
    max-width: 104px;
    object-fit: contain;
}

.sli-eids-verified span {
    min-width: 0;
    font-size: 11.5px;
    line-height: 16px;
    font-weight: 600;
    white-space: nowrap;
}

@media (max-width: 520px) {
    .sli-eids-row {
        margin-top: 6px;
    }

    .sli-eids-verified {
        gap: 6px;
        min-height: 28px;
        padding: 3px 7px 3px 5px;
    }

    .sli-eids-verified img {
        height: 20px;
        max-width: 96px;
    }

    .sli-eids-verified span {
        font-size: 11px;
    }
}

.sli-list-badges {
    float: left;
    width: 100%;
    clear: both;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 2px;
    margin-bottom: 8px;
}

.sli-sale-badge {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 6px;
    border: 1px solid rgba(218, 36, 29, .18);
    background: rgba(218, 36, 29, .06);
    color: #da241d;
    font-size: 12px;
    line-height: 1;
    font-weight: 500;
}

.sli-category-text {
    color: #666;
    font-size: 12.5px;
    line-height: 1.3;
}

.sli-date-row {
    margin-top: 2px;
    margin-bottom: 8px;
}

.sli-list-feature-grid {
    float: left;
    width: 100%;
    clear: both;
    margin-top: 4px;
}

.sli-list-feature-grid ul {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    float: none;
    width: 100%;
    margin: 0;
    padding: 0;
}

.sli-list-feature-grid li {
    float: none;
    display: block;
    min-width: 0;
}

.sli-list-feature-grid .feature-item {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #444;
    font-size: 12.5px;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
}

.sli-list-feature-grid .feature-item i {
    flex: 0 0 auto;
    font-size: 15px;
    color: #666;
}

.sli-list-feature-grid .feature-key {
    flex: 0 0 auto;
    color: #666;
    font-weight: 400;
}

.sli-list-feature-grid .feature-value {
    min-width: 0;
    color: #333;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 768px) {
    .sli-list-feature-grid ul {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 520px) {
    .sli-list-feature-grid ul {
        grid-template-columns: 1fr;
    }
}

.floorplan-item-title a{
    color:inherit;
    font-weight:inherit;
    display:block;
}

.floorplan-item-title a:hover{
    text-decoration:underline;
}
</style>
